<template>
  <div>
    <base-table :loading="isLoading" :fields="fields" :items="items" class="tw-mt-2">
      <template #status="{item: invite}">
        <base-badge class="tw-whitespace-nowrap" v-if="invite.isOpen === true" :color="badgeColor('Pending')">Pending</base-badge>
        <base-badge class="tw-whitespace-nowrap" v-else :color="badgeColor('Closed')">Closed - {{ invite.closedReason }}</base-badge>
      </template>
      <template #invite="{item: invite}">
        <div>{{ invite.businessLocationName }}</div>
        <div v-for="businessPlan in invite.businessPlans" :key="businessPlan.businessPlanId">
          <div class="tw-text-xs tw-text-gray-500">{{ businessPlan.businessPlanName }}</div>
        </div>
      </template>
      <template #sent="{item: invite}">
        <div>{{ formatDate(invite.createdDate) }}</div>
        <div v-if="invite.createdBy !== 'System'" class="tw-text-xs tw-text-gray-500 tw-flex">
          {{ invite.createdBy }}
        </div>
      </template>
      <template #actions="{item: invite}">
        <div class="tw-flex tw-items-center tw-space-x-2">
          <base-button v-if="invite.isOpen === true" type="flat" @click="del(invite)">
            <template v-slot:icon>
              <trash-icon /> </template
            >Close
          </base-button>
        </div>
      </template>
      <template #empty-state>
        <div class="tw-flex tw-justify-center tw-py-5">
          No Results
        </div>
      </template>
      <template #loading-row>
        <td class="tw-py-3 tw-px-4">
          <div class="tw-flex tw-flex-col">
            <base-skeleton-loader class="tw-h-6 tw-w-20 tw-rounded-full" />
          </div>
        </td>
        <td class="tw-py-3 tw-px-4">
          <div class="tw-flex tw-flex-col">
            <base-skeleton-loader class="tw-h-6 tw-w-20 tw-rounded-full" />
          </div>
        </td>
        <td class="tw-py-3 tw-px-4">
          <div class="tw-flex tw-flex-col">
            <base-skeleton-loader class="tw-h-6 tw-w-20 tw-rounded-full" />
          </div>
        </td>
        <td class="tw-py-3 tw-px-4">
          <div class="tw-flex tw-flex-col">
            <base-skeleton-loader class="tw-h-6 tw-w-20 tw-rounded-full" />
          </div>
        </td>
      </template>
    </base-table>
    <business-member-invite-delete :businessId="businessId" :userId="userId" ref="deleteConfirmationModal" @delete="loadInvites()" />
  </div>
</template>
<script>
import { TrashIcon } from "@/assets/svgs";
import moment from "moment";
import BusinessMemberInviteDelete from "@/views/business/member/components/BusinessMemberInviteDelete";

export default {
  name: "BusinessMemberInvites",
  components: { TrashIcon, BusinessMemberInviteDelete },
  props: {
    businessId: String,
    userId: String,
  },
  data() {
    return {
      isLoading: false,
      fields: [
        { title: "Status", key: "status", thClass: "tw-w-0" },
        { title: "Invite", key: "invite", thClass: "" },
        { title: "Invite Sent", key: "sent" },
        { title: "Actions", key: "actions", thClass: "tw-w-0 tw-text-center" },
      ],
      items: [],
    };
  },
  created() {
    this.loadInvites();
  },
  methods: {
    badgeColor(status) {
      if (status) {
        if (status.toLowerCase() === "pending") return "green";
        else return "gray";
      } else return "gray";
    },
    loadInvites() {
      this.isLoading = true;
      let url = `/businesses/${this.businessId}/members/${this.userId}/invites`;

      this.$axios
        .get(url)
        .then((res) => {
          this.items = this.sortItems(res.data.items);
        })
        .catch((err) => {
          this.EventBus.$emit("GLOBAL_ERROR", {
            title: "Failed to load invites",
            message: "We had a problem retrieving the list of invites. Please reload the page to try again.",
            error: err,
          });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    formatDate(date) {
      if (date) return new moment.utc(date).local().format("MMM DD, YYYY h:mm a");
    },
    sortItems(items) {
      var pendingArray = items.filter((i) => i.isOpen !== false).sort((a, b) => a.createdDate - b.createdDate);
      var closedArray = items.filter((i) => i.isOpen === false).sort((a, b) => a.createdDate - b.createdDate);

      return pendingArray.concat(closedArray);
    },
    del(item) {
      this.$refs.deleteConfirmationModal.show(item);
    },
  },
  watch: {
    userId() {
      this.loadInvites();
    },
  },
};
</script>
